module.exports = "/dist/50825d47af7ae47e055018eb689c6c99.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500.woff
// module id = 124
// module chunks = 0